
import { Card, Col, Container, Row } from "react-bootstrap";
import { Fragment, useMemo, useState } from "react";
import { getResult } from "../services/MSurveyService";
import ResultComponent from "../components/ResultComponent";
import ResultSummary from "../components/ResultSummary";
import ResultFilter from "../components/ResultFilter";
import Button from '@mui/material/Button';

interface SurveyResult {
    id: string,
    contactId: string,
    createdAt: Date,
    createdAtStr: string,
    custCode: string,
    email: string,
    contactName: string,
    mobileNumber: string,
    contactBack: boolean,
    comment: string,
    rating: number
}

export default function Result(): JSX.Element {
    const [result, setResult] = useState<SurveyResult[]>([]);
    const [avgRating, setAvgRating] = useState(0);
    const [resultArr, setResultArr] = useState([0, 0, 0, 0, 0, 0]);
    const [showData, setShowData] = useState<SurveyResult[]>([]);
    const [custCode, setCustCode] = useState('');
    const [comment, setComment] = useState('');
    const [commentCheck, setCommentCheck] = useState(true);
    let _from = new Date();
    _from.setHours(0);
    _from.setMinutes(0);
    _from.setSeconds(0);
    let _to = new Date();
    _to.setHours(23);
    _to.setMinutes(59);
    _to.setSeconds(59);
    const [fromDate, setFromDate] = useState<Date | null>(_from);
    const [toDate, setToDate] = useState<Date | null>(_to);
    const [contactBack, setContactBack] = useState<boolean>(false);
    const [rating, setRating] = useState<string>('all');

    useMemo(() => {
        getResult()
            .then(r => {
                let sumRating = 0;
                let _resultArr = [0, 0, 0, 0, 0, 0];
                let _result = r.data
                .filter((rd: { sresult: string; id: string; contactId: string; custCode: string; createdAt: string; bcustcode: string; bcontactId: string; }) => {
                    try {
                      JSON.parse(rd.sresult);
                      return true;
                    } catch (e) {
                        console.error("Error Parsing JSON id :" + rd.id)
                        return false;
                    }
                })
                .map((rd: { sresult: string; id: string; contactId: string; custCode: string; createdAt: string; bcustcode: string; bcontactId: string; }) => {
                    const j = JSON.parse(rd.sresult);
                    const _email = j.email;
                    const _contactName = j.contactName;
                    const _mobileNumber = j.mobileNumber;
                    const _contactBack = j.contactBack;
                    const _comment = j.comment;
                    const _rating = j.rating;
                    let d = new Date();
                    let _year = parseInt(rd.createdAt.substring(0, 4));
                    let _month = parseInt(rd.createdAt.substring(5, 7));
                    let _date = parseInt(rd.createdAt.substring(8, 10));
                    let _h = parseInt(rd.createdAt.substring(11, 13));
                    let _m = parseInt(rd.createdAt.substring(14, 16));
                    let _s = parseInt(rd.createdAt.substring(17, 19));
                    let _mVal = _month - 1;
                    d.setFullYear(_year);
                    d.setMonth(_mVal);
                    d.setDate(_date);
                    d.setHours(_h);
                    d.setMinutes(_m);
                    d.setSeconds(_s);
                    d.setHours(d.getHours() + 7);
                    let _dateStr = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
                    let _monthStr = _mVal + 1 < 10 ? `0${_mVal + 1}` : _mVal + 1;
                    let _hStr = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
                    let _minStr = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
                    let _sStr = d.getSeconds() < 10 ? `0${d.getSeconds()}` : d.getSeconds();
                    let _createdAt = `${_dateStr}/${_monthStr}/${d.getFullYear()} ${_hStr}:${_minStr}:${_sStr}`;
                    return {
                        id: rd.id,
                        contactId: rd.contactId ? rd.contactId : rd.bcontactId,
                        createdAt: d,
                        createdAtStr: _createdAt,
                        custCode: rd.custCode ? rd.custCode : rd.bcustcode,
                        email: _email,
                        contactName: _contactName,
                        mobileNumber: _mobileNumber,
                        contactBack: _contactBack,
                        comment: _comment,
                        rating: _rating
                    }
                })
                setResult(_result);
                let _f = new Date();
                _f.setHours(0);
                _f.setMinutes(0);
                _f.setSeconds(0);
                let _t = new Date();
                _t.setHours(23);
                _t.setMinutes(59);
                _t.setSeconds(59);
                const _showData = _result.filter((r: SurveyResult) => r && r.comment !== '' && (r.createdAt.getTime() >= _f.getTime() && r.createdAt.getTime() <= _t.getTime()));
                _showData.forEach((s: SurveyResult) => {
                    sumRating += s.rating;
                    switch (s.rating) {
                        case 0:
                            _resultArr[0] += 1;
                            break;
                        case 1:
                            _resultArr[1] += 1;
                            break;
                        case 2:
                            _resultArr[2] += 1;
                            break;
                        case 3:
                            _resultArr[3] += 1;
                            break;
                        case 4:
                            _resultArr[4] += 1;
                            break;
                        case 5:
                            _resultArr[5] += 1;
                            break;
                        default:
                            break;
                    }
                })
                let _avgRating = sumRating / _showData.length;
                setAvgRating(_avgRating);
                setShowData(_showData);
                setResultArr(_resultArr);
            })
    }, [])

    const handleFContactBackChange = (c: boolean) => {
        setContactBack(c);
    }

    const handleSearchClick = () => {
        let _showData = result;
        if (commentCheck) {
            _showData = _showData.filter((r: SurveyResult) => r.comment !== '');
        }

        if (custCode) {
            _showData = _showData.filter((r: SurveyResult) => r.custCode.includes(custCode) && r.comment.includes(comment));
        }

        if (fromDate && toDate) {
            _showData = _showData.filter((r: SurveyResult) => r.createdAt.getTime() >= fromDate.getTime() && r.createdAt.getTime() <= toDate.getTime());
        }
        if (contactBack) {
            _showData = _showData.filter((r: SurveyResult) => r.contactBack === true);
        }
        if (rating !== 'all') {
            _showData = _showData.filter((r: SurveyResult) => r.rating === parseInt(rating));
        }
        setShowData(_showData);
        let sumRating = 0;
        let _resultArr = [0, 0, 0, 0, 0, 0];
        _showData.forEach((s: SurveyResult) => {
            sumRating += s.rating;
            switch (s.rating) {
                case 0:
                    _resultArr[0] += 1;
                    break;
                case 1:
                    _resultArr[1] += 1;
                    break;
                case 2:
                    _resultArr[2] += 1;
                    break;
                case 3:
                    _resultArr[3] += 1;
                    break;
                case 4:
                    _resultArr[4] += 1;
                    break;
                case 5:
                    _resultArr[5] += 1;
                    break;
                default:
                    break;
            }
        })

        let _avgRating = sumRating / _showData.length;
        setAvgRating(_avgRating);
        setResultArr(_resultArr);
    }

    return (
        <Container>
            <Card>
                <Card.Body>
                    <Row>
                        <Col lg='10'>
                            <ResultFilter
                                onCustCodeChange={(c: string) => setCustCode(c)}
                                onCommentChange={(c: string) => setComment(c)}
                                onCommentCheckChange={(c: boolean) => setCommentCheck(c)}
                                onDateChange={(from: Date | null, to: Date | null) => {
                                    setFromDate(from);
                                    setToDate(to);
                                }}
                                onContactBackChange={(c: boolean) => handleFContactBackChange(c)}
                                onRatingChange={(r: string) => setRating(r)}
                            />
                        </Col>
                        <Col lg='2' className='search-div'>
                            <Button className='search-btn' variant="contained" size="large" onClick={handleSearchClick}>
                                Search
                            </Button>
                        </Col>
                    </Row>
                    <ResultSummary avgRating={avgRating} total={showData.length} resultArr={resultArr} />
                    <h4>Customer Reviews</h4>
                    {showData.map((s, i) => (
                        <Fragment key={s.id}>
                            <ResultComponent createdAt={s.createdAtStr} custCode={s.custCode} rating={s.rating} comment={s.comment} contactId={s.contactId} contactBack={s.contactBack} />
                            <hr />
                        </Fragment>
                    ))}
                </Card.Body>
            </Card>
        </Container >
    )
}